module.exports = __webpack_public_path__ + "media/legacy/components/MainSection/iphone-video-placeholder-b81ff9298f10b4355b8d06bc6053f44c.jpg";